export function detectBrowser() {
    if (navigator.userAgent.indexOf("Opera") != -1 || navigator.userAgent.indexOf('OPR') != -1) {
        return 'Opera';
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        return 'Chrome';
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
        return 'Safari';
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        return 'Firefox';
    } else {
        return 'Unknown';
    }
}

export const isUserOnChromeIOS = () => {
    return navigator.userAgent.indexOf('CriOS') >= 0; // iOS&Chrome?
};

export const printOnIOSChrome = (styles: any, contentToPrint: any, shouldCenter: Boolean | undefined = true) => {
    //workaround for chrome on iOS
    //This will need to be adjusted when chrome gets its own native engine on iOS as opposed to webkit
    const modalToPrint: any = window.open('', '');
    modalToPrint.document.open();
    const style = modalToPrint.document.createElement('style');
    if (shouldCenter) {
        modalToPrint.document.write(
            '</head><body onLoad="self.print()"><center>',
        );
    } else {
        modalToPrint.document.write(
            '</head><body onLoad="self.print()">',
        );
    }
    modalToPrint.document.write(contentToPrint.innerHTML);
    style.innerHTML = styles;
    modalToPrint.document.head.appendChild(style);
    if (shouldCenter) {
        modalToPrint.document.write('</center></body></html>');
    } else {
        modalToPrint.document.write('</body></html>');
    }
    modalToPrint.addEventListener('afterprint', () => {
        modalToPrint.close();
    });
    modalToPrint.document.close();

};

/**
 * Workaround to print a model if the user is running chrome (webkit engine)on iOS
 * Uses a workaround by creating a new tab that renders the content.
 * Then it dismisses the tab immediatel after the print dialog is open taking
 * the user back to the previous page
 * 
 * @param styles The sass style to render the modal to be printed
 * @param contentToPrint: useRef<HTMLDivElement>(null);
 */


export const createProgressiveMask = (mask: string, allowedChars: RegExp | string = '0', displayChar, charactersToAddEagerly: string[] = []) => {
    if(!mask){
        return;
    }
    const newMask: Record<string, any>[]= []
    const isAllowedCharsRegex = typeof allowedChars === 'object';
    const validateWithRegex = isAllowedCharsRegex ? (value) => value.match(allowedChars) && value.match(allowedChars).length === value.length : null;
    const chars = isAllowedCharsRegex ? '*' : allowedChars;
    let progressiveMask = [chars];
    const definitions = {
        X: {
            mask: chars,
            displayChar: displayChar,
            expose: true,
            overwrite: 'shift',
        }
    }
    //first char entered must display
    newMask.push({
        mask: chars,
        validate: validateWithRegex
    })
    for (let i = 0; i < mask.length; i++) {
        let characterToAddEagerly = '';
        const lookaheadIndex = i + 2;
        progressiveMask.splice(progressiveMask.length - 1, 0, mask[i])
        // ensure mask definitions include eagerly added characters
        if (charactersToAddEagerly.includes(mask[lookaheadIndex])) {
            characterToAddEagerly = mask[lookaheadIndex];
        }
        if (mask[i + 1] && mask[i + 1] === 'X') {
            newMask.push(
                {
                    mask: progressiveMask.join('') + characterToAddEagerly,
                    definitions: definitions,
                    validate: validateWithRegex
                }
            )
        }
    }

    return newMask;
}

export const addUnderscores = (id?: string, alternateId?: string) => {
    if(id) {
        let updatedID = id.trim();
        updatedID = updatedID.replace(/ /g, '_');
        return updatedID;
    } else if (alternateId) {
        let updatedID = alternateId.trim();
        updatedID = updatedID.replace(/ /g, '_');
        return updatedID;
    } else {
        return '';
    }
}